// precision mediump float;

uniform vec3 uColor;
uniform sampler2D uTexture;

varying vec2 vUv;
varying float vElevation;

// varying float vRandom;

void main(){
    vec4 textureColor = texture2D(uTexture, vUv);
    // gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);
    // gl_FragColor = vec4(vRandom, vRandom * 0.5, 1.0, 1.0); // in script.js transparent:true
    // gl_FragColor = vec4(uColor, 1.0);
    textureColor.rgb *= vElevation * 2.0 + 0.7;
    gl_FragColor = textureColor;
}